// extracted by mini-css-extract-plugin
export default {"card":"VideoCarousel_card__CKpDJ"};